<template>
  <div>
    <!-- Start Sample Area -->
    <section class="sample-text-area">
      <div class="container">
        <h3 class="text-heading title_color">{{ text.title }}</h3>
        <p class="sample-text text-color">
          {{ text.content }}
        </p>
        <div class="div-card fadeIn animated">
          <p class="sample-text text-color card">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ text.pwertText }}
          </p>
          <p class="sample-text text-color card">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ text.epmsText }}
          </p>
        </div>

      </div>
    </section>
    <!-- End Sample Area -->

    <!-- Start Align Area -->

    <div class="whole-wrap warp-padding">

      <div class="container">
        <p class="sample-text text-color">{{ text.taskText }}
        </p>
      </div>
      <h4 style="text-align: center;"><br /><br />采用领域驱动设计(DDD)的软件开发设计方法，实现对用户业务需求进行微服务拆分。</h4>
      <div class="container" v-for="(v, i) in details" :key="i">

        <div class="section-top-border fadeInLeft animated">

          <h3 class="mb-30 title_color ">{{ v.left.title }}</h3>
          <div class="row">
            <div class="col-md-3 row-img">
              <img src="static/assets/images/elements/d.png" alt="" class="img-fluid">
            </div>
            <div class="col-md-9 mt-sm-20 left-align-p">
              <p>{{ v.left.content }}</p>
            </div>
          </div>
        </div>
        <div class="section-top-border text-right fadeInRight animated">
          <h3 class="mb-30 title_color">{{ v.right.title }}</h3>
          <div class="row">
            <div class="col-md-9">
              <p class="text-right">{{ v.right.content }}</p>
            </div>
            <div class="col-md-3 row-img">
              <img src="static/assets/images/elements/dr.png" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Align Area -->
  </div>
</template>

<script>
export default {
  name: 'dtability',
  data () {
    return {
      text: {
        title: '研发能力',
        content: '公司在软件研发过程中遵循国际规范标准，在ISO 9001质量管理体系和ISO 27001信息安全体系平台之上，结合CMMI L3软件成熟度模型，对软件开发从开发计划、需求调用、系统设计，到研发、测试、用户培训、部署实现全过程覆盖，通过敏捷迭代开发模式实现软件过程的持续改进，提升软件开发流程工艺技术水平，增强了开发高品质软件的能力。',
        pwertText: '在电力行业主要实施ePMS系统(IFS ERP软件产品)，该系统采用面向服务的SOA三层技术架构、数据层采用oracle数据库、中间层采用java开发的中间件、用户展现层使用IFSEE企业浏览器，采用C#语言编写的用户展现界面。',
        epmsText: '实施了ePMS系统迁移到大数据云端部署，数据库从11g升级到19c，掌握oracle数据库TB级大数据量升级迁移能力，并保持系统稳定运行。根据客户提出的各种需求问题，进行了大量的接口开发及高能力技术整合。',
        taskText: '公司自主研发了任务跟踪管理系统(TASKMS)，采用最新的微服务架构，前后端分离、部署在微服务运维一体化云平台上，实现对用户各种业务任务的跟踪管理。系统采用了主流的Spring Cloud、Springboot、Nacos服务注册发现、RabbitMQ、分布式事务处理、Vue前端框架等技术栈进行敏捷迭代开发，满足用户需求的快速变化与实现。持久化方面支持多种数据库：MySQL、PostgreSQL、国产达梦和OceanBase等数据库。'
      },

      details: [
        {
          left: {
            title: '合理的进行服务拆分',
            content: '根据业务能力进行服务拆分根据子域进行服务拆分单一职责原则：从业务能力/子域拆分方面来理解单一职责。 闭包原则：在包中包含的所有类应该是对同类变化的一个集合，也就是说，如果对包做出修改，需要调整 的类应该都在这个包之内。'
          },
          right: {
            title: 'API优先的设计',
            content: '使用API优先方法进行设计意味着构建一个不仅仅是内部系统副产品的API。开发人员应该能够快速又轻松地了解 API的工作方式，并与其他应用程序集成在一起。只有这样，开发者才能编写优雅的代码，以便与其他系统进行有效的交互，标准 就是正确运行API时，它既向后兼容又往前扩展。'
          }
        },
        {
          left: {
            title: '设计可观测的服务',
            content: '健康检查API;日志聚合;分布式跟踪'
          },
          right: {
            title: '使用微服务基底模式开发服务',
            content: '异常追踪、日志记录、健康检查、外部化配置和分布式追踪是微服务需要解决的共性问题。我们需要在能够处理那些共性问题的框架或框架集 合上构建服务。'
          }
        },
        {
          left: {
            title: '微服务部署为容器',
            content: '容器是更轻量级的部署机制，是一个操作系统级的虚拟化机制。容器通常包含一个或多个在沙箱中运行的进程，这个沙箱将它们与其它容器隔离。'
          },
          right: {
            title: '开发安全的服务',
            content: '由API Gateway处理身份验证在微服务架构中使用OAuth2.0'
          }
        }
      ]

    }
  }
}
</script>

<style scoped>
/*base code*/
.row-img {
  text-align: center;
}

.warp-padding {
  padding: 0 0 150px;
}

.text-color {
  color: #000;
}

.div-card {
  display: flex;
  justify-content: space-around;
  margin-top: 16px;
}

.card {
  width: 410px;
  height: 190px;
  border-radius: 30px;
  background: #e0e0e0;
  box-shadow: 15px 15px 30px #bebebe,
    -15px -15px 30px #ffffff;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// Dtability.vue?60efd510